module.exports = __webpack_public_path__ + "static/media/3.acdbab77.png";